import { render, staticRenderFns } from "./demandList.vue?vue&type=template&id=c382da00&scoped=true"
import script from "./demandList.vue?vue&type=script&lang=js"
export * from "./demandList.vue?vue&type=script&lang=js"
import style0 from "./demandList.vue?vue&type=style&index=0&id=c382da00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c382da00",
  null
  
)

export default component.exports